import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {
    Button,
    Typography
} from "@mui/material";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {SETTINGS_TYPES} from "../../../data/SettingsType";
import UtilityServiceComposition from "../../../API/common/UtilityServiceComposition";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import NameModal from "../../../components/UI/modal/NameModal";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";

const CompositionMedia = ({itemId, handleModalAlert}) => {
    const pathname = useLocation().pathname
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [loading, setLoading] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 7,
        searchData: ""
    })

    useEffect(() => {
        getStartPageSize()
        UtilityServiceComposition.get().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    const handleClose = () => {
        setModal(false)
        setCurrentEditRowData(null)
    }
    const handleAdd = () => {
        setModal(true)
    }
    const handleEdit = (row) => {
        setCurrentEditRowData(row);
        setModal(true)
    };
    const handleUpdate = (value) => {
        setLoading(true)
        UtilityServiceComposition.edit(currentEditRowData.id, value)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
                handleClose()
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }
    const handleDelete = (row) => {
        UtilityServiceComposition.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };
    const handleSubmit = (value) => {
        setLoading(true)
        UtilityServiceComposition.add(value)
            .then(function (response) {
                setData(prev => [...prev, response.data])
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
                handleClose()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))

    }

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'name', minSize: 800,
            },
            {
                id: 'file',
                header: 'Файлы',
                accessorKey: 'file',
                minSize: 15,
                maxSize: 15,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                enableSorting: false,
                Cell: ({row}) => (
                    <Button
                        size="small"
                        sx={{minWidth: 'auto', marginLeft: 'auto'}}
                        color="pencil"
                        onClick={() => navigate('/settings/composition-media/' + row.original.id+'/'+row.original.name)}
                    >
                        <DriveFileMoveIcon sx={{minWidth: 'auto', marginLeft: 'auto', fontSize: 20}}/>
                    </Button>
                ),
            }
        ]
        return baseColumns;

    }, [data]);

    const menuItem = [{type: "edit", text: "Изменить", handler: handleEdit}, {
        type: "delete",
        text: "Удалить",
        handler: handleDelete
    }]

    return (<Box sx={{
        overflow: 'auto',
        maxWidth: 'calc(100vw - 410px)',
    }}>
        <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
        >
            <Typography sx={{
                fontSize: "24px",
                fontWeight: 700,
                lineHeight: 1
            }}>{SETTINGS_TYPES[itemId]}</Typography>
            <ButtonCreate
                text={"Добавить"}
                width={130}
                onClick={handleAdd}
            />
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: '1000px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            onGlobalFilterChange={value => tableOptionsHandle({...tableOptions, searchData: value})}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            state={{showGlobalFilter: true, pagination: tableOptions}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })}
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        <NameModal
            title={currentEditRowData ? "Изменить" : "Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={currentEditRowData ? handleUpdate : handleSubmit}
            initValue={currentEditRowData}
            loading={loading}
        />
    </Box>);
}
export default CompositionMedia;